import { render, staticRenderFns } from "./VipUserPicker.vue?vue&type=template&id=a926198a"
import script from "./VipUserPicker.vue?vue&type=script&lang=js"
export * from "./VipUserPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports